import './KnownIssuesAddPage.css'
import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { IPageProps } from 'types'
import { DefaultButton, FormDropDownList, FormInput, PageHeader, ReturnButton, FormTextArea, FormDateTimePicker, FormMultiSelect } from 'components'
import { useEffect, useRef, useState } from 'react'
import { FormElement, Field, Form, FormClassComponent, } from '@progress/kendo-react-form'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'state/store'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'
import toast from 'core/toast'
import { CreateKnownIssueDto, KnownIssueDto } from 'generated/v1/v1IntegrationsApi'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { RequiredValidator } from 'core/Validators'
import moment from 'moment'

const KnownIssuesAddPage = ({ title }: IPageProps) => {

    const formRef = useRef<FormClassComponent>(null)
    const dispatch = useDispatch<AppDispatch>()
    const statusData = ['Reported', 'In Process', 'Awaiting Deployment', 'Deployed', 'Deleted']
    const systemData = ['DCS', 'Sys Admin', 'CMS', 'Mobile', 'Other']
    const navigate = useNavigate()
    const reportDateDefault = moment().toDate()

    const [loaded, setLoaded] = useState(false)
    const [knownIssue, setKnownIssue] = useState<KnownIssueDto>(new KnownIssueDto())

    useEffect(() => {
        if (knownIssue.reportedDate == undefined) {
            setKnownIssue(new KnownIssueDto({
                ...knownIssue,
                reportedDate: (reportDateDefault),
                status: 'Reported',
            }))
            setLoaded(true)
        }
    }, [])

    const handleSubmit = async (values: CreateKnownIssueDto) => {
        try {
            await dispatch(startLoadingAction())

            var result = await V1ApiIntegrationsClient.createKnownIssue(values, undefined)

            if (result.success) {
                toast.success('Successfully added Known Issue')
                navigate('/integrations/known-issues')
            }
            else {
                toast.responseErrors(result.errors)
            }

        } catch (e) {
            toast.responseErrors(e)
        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    return (
        <div id='KnownIssuesAddPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/integrations/known-issues' />
            </PageHeader>

            {loaded &&
                <Form
                    onSubmit={(e) => handleSubmit(e as CreateKnownIssueDto)}
                    ref={formRef}
                    ignoreModified={true}
                    initialValues={knownIssue}
                    key={JSON.stringify(knownIssue)}
                    render={(formRenderProps) => (
                        <FormElement>
                            <div className='bg-light border p-3'>
                                <Row className='mb-6'>
                                    <Col md={6}>
                                        <Field
                                            label='Title:'
                                            name='title'
                                            component={FormInput}
                                            validator={RequiredValidator}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mb-12'>
                                    <Col md={12}>
                                        <Field
                                            label='Description:'
                                            name='description'
                                            component={FormTextArea}
                                            validator={RequiredValidator}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={3}>
                                        <Field
                                            label='Report Date:'
                                            name='reportedDate'
                                            component={FormDateTimePicker}
                                            defaultValue={reportDateDefault}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Field
                                            label='Status:'
                                            name='status'
                                            validator={RequiredValidator}
                                            component={FormDropDownList}
                                            defaultValue='Reported'
                                            data={statusData}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Field
                                            label='System:'
                                            name='systemArray'
                                            validator={RequiredValidator}
                                            component={FormMultiSelect}
                                            defaultValue=''
                                            data={systemData}
                                        />
                                    </Col>

                                    <Col md={3} style={{ alignSelf: 'end' }}>
                                        <DefaultButton variant='primary' className='w-100' type='submit'>Add Known Issue</DefaultButton>
                                    </Col>
                                </Row>
                            </div>
                        </FormElement>
                    )
                    }
                />
            }
        </div>
    )
}
export default KnownIssuesAddPage
